<template>
    <h3>Guest Home</h3>
</template>

<script>
export default {
    name: 'GuestHomeView'
}
</script>